module.exports = __webpack_public_path__ + "img/explanation.ba5a095d.svg";